import React, { useContext } from "react"
import { observer } from "mobx-react"
import { Anchor, Text, Title } from "@mantine/core"
import { IconArrowRight } from "@tabler/icons-react"
import { AppWorkspaceContext } from "../../stores/AppWorkspace"
import { LANDING_COPY } from "../../../docs/catalog"
import { LIVE_PROCESSORS } from "../../../processors/catalog"
import { PROCESSORS_HASH, PROCESSORS_PATH } from "../../helpers/constants"
import { ProcessorCard } from "./ProcessorCard"

// The homepage's PAYMENT PROCESSORS section: one card per live row in
// config/processors.json, in the platforms' style. Planned rows live on
// /processors only, the same as the platform grid.
export const ProcessorGrid: React.FC = observer(() => {
  const workspace = useContext(AppWorkspaceContext)
  const copy = LANDING_COPY.processors
  if (LIVE_PROCESSORS.length === 0) return null

  return (
    <section id={PROCESSORS_HASH} className="or-frameworks or-platforms" aria-labelledby="or-processors-title">
      <Text className="or-eyebrow">{copy.eyebrow}</Text>
      <Title order={2} id="or-processors-title" className="or-frameworks-title">
        {copy.headline}
      </Title>
      <Text className="or-frameworks-lede">{copy.subline}</Text>

      <ul className="or-framework-cards">
        {LIVE_PROCESSORS.map((processor) => (
          <ProcessorCard key={processor.id} processor={processor} />
        ))}
      </ul>

      <Anchor
        className="or-platforms-all"
        href={PROCESSORS_PATH}
        onClick={(event) => {
          event.preventDefault()
          workspace.goProcessors()
        }}
      >
        See all payment processors <IconArrowRight size={14} aria-hidden="true" />
      </Anchor>
    </section>
  )
})
